import axios from 'axios';
import { API_BASE } from '../config';


const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});

// دریافت لیست پروژه‌هایی که کاربر به آن‌ها دسترسی دارد
export const getAllProjects = async () => {
  const res = await axios.get(`${API_BASE}projects`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });
  return res.data;
};


export const getProjectById = async (id) => {
  try {
    const res = await axios.get(`${API_BASE}projects/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    return res.data;
  } catch (error) {
    console.error('خطا در دریافت پروژه با آیدی:', id, error);
    return null; // یا throw error; اگر بخوای بالا مدیریت بشه
  }
};

// ایجاد پروژه جدید
export const createProject = async (projectData) => {
  try {
    const res = await axios.post(`${API_BASE}projects`, projectData, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در ایجاد پروژه:', err);
    throw new Error(err.response?.data?.message || 'ایجاد پروژه با خطا مواجه شد.');
  }
};

//ویرایش پروژه موجود
export const updateProject = async (projectId, projectData) => {
  try {
    const res = await axios.put(`${API_BASE}projects/${projectId}`, projectData, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در ویرایش پروژه:', err);
    throw new Error(err.response?.data?.message || 'ویرایش پروژه با خطا مواجه شد.');
  }
};

// حذف پروژه
export const deleteProject = async (projectId) => {
  try {
    const res = await axios.delete(`${API_BASE}projects/${projectId}`, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در حذف پروژه:', err);
    throw new Error(err.response?.data?.message || 'حذف پروژه با خطا مواجه شد.');
  }
};